import { render, staticRenderFns } from "./TextResultsNoData.vue?vue&type=template&id=153d7792&"
import script from "./TextResultsNoData.vue?vue&type=script&lang=js&"
export * from "./TextResultsNoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('153d7792')) {
      api.createRecord('153d7792', component.options)
    } else {
      api.reload('153d7792', component.options)
    }
    module.hot.accept("./TextResultsNoData.vue?vue&type=template&id=153d7792&", function () {
      api.rerender('153d7792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/weight/contentParts/TextResultsNoData.vue"
export default component.exports